import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ColorInput as CommonColorInput } from '@blueprintnyc/bpnyc-common-admin';

const presetColors = [
	'#FFFFFF',
	'#D9D9D9',
	'#969696',
	'#000000',
	'#D9534F',
	'#E53F6F',
	'#9031AA',
	'#3F51B5',
	'#62B1F6',
	'#5CB85C',
	'#F0AD4E',
	'#FCEC60',
	// remaining default colors not incuded default 12 when custom theme is available
	// used to check whether palette should be custom or default
	'#613CB0',
	'#235696',
	'#4994EC',
	'#97C15C',
	'#D0DC59',
	'#F6C344',
];

const themeElements = [
	'brandPrimary',
	'brandSecondary',
	'navBg',
	'navIconAndText',
	'headerBg',
	'headerText',
	'btnPrimaryBg',
	'btnInfoBg',
	'btnSuccessBg',
];

const formatColor = colorStr => {
	const hex = colorStr.toUpperCase();
	return hex.length <= 7 ? (hex + hex.split('#')[1]).substring(0, 7) : hex;
};

const themeReducer = theme => [
	...presetColors.slice(0, 12),
	...Object.entries(theme).reduce((swatches, [key, val]) => {
		if (themeElements.includes(key)) {
			const hexCode = formatColor(val);
			if (!swatches.includes(hexCode) && !presetColors.includes(hexCode)) swatches.push(hexCode);
		}
		return swatches;
	}, []),
];

const ColorInput = props => {
	const {
		currentEvent,
		color,
		value,
		swatchColors: parentSwatchColors,
		onChange,
		onSubmit,
		autosave,
		defaultColor,
	} = props;

	const theme = currentEvent.theme;
	const swatchColors = parentSwatchColors ? parentSwatchColors : themeReducer(theme);
	const [hexCode, setHexCode] = useState('');

	useEffect(() => {
		setHexCode(value ? value : color);
	}, [value, color]);

	const handleSubmit = hex => {
		if (onSubmit) {
			!hex && defaultColor ? onSubmit(defaultColor) : onSubmit(hex);
		}
	};

	const handleChange = color => {
		if (onChange) {
			onChange(color);
		}
	};

	const colorProps = {
		color: hexCode ? hexCode.toUpperCase() : '',
		swatchColors,
		onChange: handleChange,
		onSubmit: handleSubmit,
		autosave,
	};

	return (
		<div className="color-input-container">
			<CommonColorInput {...colorProps} />
		</div>
	);
};

const msp = ({ events }) => ({
	currentEvent: events.currentEvent,
});

export default connect(msp)(ColorInput);
